<template>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" fixed app>
    <v-app-bar-nav-icon
      v-show="$vuetify.breakpoint.mdAndDown"
      @click="$emit('toolbarSideIconClick')"
    />
    <v-toolbar-title style="position: relative">
      <router-link to="/" tag="span" style="cursor: pointer">
        <v-avatar :tile="true" size="35">
          <v-img src="static/common/icons/HeedView-icon-192.png" />
        </v-avatar>
        HeedView
        <div
          style="color: lightgray; position: absolute; bottom: -2px; left: 58px;"
          class="caption"
        >
          {{ version }}
        </div>
      </router-link>
    </v-toolbar-title>

    <!-- Spacer -->
    <div style="width: 25px;" />
    <!--  Toolbar items for large screen  -->
    <v-toolbar-items class="hidden-md-and-down toolbar">
      <v-menu
        v-for="(item, index) in toolbarItemsAccessibleToUser"
        :key="index"
        open-on-hover
        nudge-bottom="50"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            :id="item.idPrefix + '--toolbar-btn'"
            text
            :title="item.name"
            v-on="on"
            @click="item.clickAction()"
          >
            <v-icon v-if="item.icon" size="18" style="margin-right: 5px">
              {{ item.icon }}
            </v-icon>
            <template>
              {{ item.name }}
            </template>
          </v-btn>
        </template>
        <v-list v-if="item.dropdownItems.length">
          <v-list-item
            v-for="(dropdownItem, index) in item.dropdownItems"
            :id="
              dropdownItem.idPrefix +
                '--dropdown-item-for-' +
                item.idPrefix +
                '-toolbar-btn'
            "
            :key="index"
            @click="dropdownItem.clickAction()"
          >
            <v-list-item-action style="margin-right: 10px">
              <v-icon>{{ dropdownItem.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ dropdownItem.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
    <!--  Toolbar items for small screen  -->
    <v-toolbar-items class="hidden-lg-and-up small-screen-toolbar">
      <v-menu open-on-hover nudge-bottom="50">
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list>
          <div v-for="(item, i) in toolbarItemsForSmallScreen" :key="i">
            <v-list-item @click="item.clickAction()">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title>
                {{ item.name }}
              </v-list-item-title>
            </v-list-item>
          </div>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { ADMIN_BASE, DJANGO_LOGOUT_URL, VERSION_KEY } from '../constants'
import ToolbarItem from '@/components/ToolbarItem'

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this
    return {
      version: localStorage.getItem(VERSION_KEY),
      /*
        All `toolbarItems` should define either a `clickAction` or `dropdownItems`,
        both together are not allowed (this restriction comes from rendering the mobile screen menu version).
      */
      toolbarItems: [
        new ToolbarItem(
          'Lisa tegevus',
          'add_box',
          () => true,
          () => {
            self.$router.push({ name: 'AddAction' })
          },
          [],
          'add'
        ),
        new ToolbarItem(
          'Kogukonna päeva kokkuvõte',
          'people',
          () => true,
          () => {
            self.$router.push({ name: 'CommunityLivingDailySummary' })
          },
          [],
          'community-daily-summary'
        ),
        new ToolbarItem(
          'Aruanded',
          'note_add',
          () => true,
          () => {
            self.$router.push({ name: 'Reports' })
          },
          [],
          'reports'
        ),
        new ToolbarItem(
          'Sünnipäevad',
          'cake',
          () => true,
          () => {
            self.$router.push({ name: 'BirthdayView' })
          },
          [],
          'birthday'
        ),
        new ToolbarItem(
          'Halduskeskkond',
          'settings_applications',
          employee => employee.isAdminOrSuperuser,
          () => {
            window.location.replace(ADMIN_BASE)
          },
          [],
          'administration'
        ),
        new ToolbarItem(
          this.user.username,
          'arrow_drop_down_circle',
          () => true,
          () => null,
          [
            new ToolbarItem(
              'Minu leht',
              'account_box',
              () => true,
              () => {
                self.$router.push({ name: 'MyPage' })
              },
              [],
              'my-page'
            ),
            new ToolbarItem(
              'Logi välja',
              'call_missed_outgoing',
              () => true,
              () => {
                window.location.replace(DJANGO_LOGOUT_URL)
              },
              [],
              'log-out'
            )
          ],
          'user'
        )
      ]
    }
  },
  computed: {
    toolbarItemsAccessibleToUser() {
      return this.toolbarItems
        .map(item => item.accessibleToEmployee(this.user))
        .filter(item => item != null) // remove inaccessible null values
    },
    /**
     * For large screen `toolbarItems` list can have a depth of two levels:
     * items and the menus opening when hovering over the item.
     * For small screen, all the options are displayed in a flat list.
     */
    toolbarItemsForSmallScreen() {
      const result = []
      for (const item of this.toolbarItemsAccessibleToUser) {
        for (const i of item.toFlat()) result.push(i)
      }
      return result
    }
  }
}
</script>
<style>
.toolbar {
  width: 100%;
}

#user--toolbar-btn,
.small-screen-toolbar {
  margin-left: auto;
}

.v-toolbar__title {
  min-width: 150px;
}
</style>
